import React, { useReducer } from 'react';

type State = {
    highlightedMenu?: string;
};

export type HelpIndicatorsAction = {
    type: string;
    stringValue?: string;
}

export enum HelpIndicatorsActionType {
    HighlightMenu = "HIGHLIGHT_MENU",
    UnHighlightMenu = "UN_HIGHLIGHT_MENU"
}

const errorNoUser = 'Error: No User!';
const emptyState: State = {
}

type ContextType = State & {
    dispatch: React.Dispatch<HelpIndicatorsAction>
};

export const HelpIndicatorsContext = React.createContext<ContextType>({
    ...emptyState,
    dispatch: () => { }
});

function reducer(state: State, action: HelpIndicatorsAction) : State {
    switch (action.type) {
        case HelpIndicatorsActionType.HighlightMenu:
            return { highlightedMenu: action.stringValue };
        case HelpIndicatorsActionType.UnHighlightMenu:
            return { highlightedMenu: undefined };
            default:
            return state;
    }
}

// "Argument of type 'State' is not assignable to parameter of type 'never'.ts(2345)"
// this error means the reducer isn't always returning a state obvject
export function HelpIndicatorsContextProvider(props: { children: JSX.Element[] | JSX.Element, initialState?: State }) {
    const [state, dispatch] = useReducer(reducer, props.initialState || emptyState);

    const value = { ...state, dispatch };
    return <HelpIndicatorsContext.Provider value={value}>{props.children}</HelpIndicatorsContext.Provider>;
}
